<mat-card>
  <smart-input [(model)]="group" key="name" translationPrefix="userAdmin.addressbook"></smart-input>
  <div class="error up" *ngIf="missingTitle && group.name?.length < 3">{{'userAdmin.errors.missingTitle' | translate}}</div>
  <div><mat-checkbox [(ngModel)]="addressbookAdmin"> {{ 'userAdmin.addressbook.admin' | translate }}</mat-checkbox></div>
</mat-card>

<data-table *ngIf="!!profiles && !!activeProfiles" [columns]="profileColumns" [plainData]="activeProfiles" [hideSearch]="true"
            [newHeader]="true" (remove)="removeProfile($event)" [title]="'userAdmin.group.assignedProfiles' | translate"
            [headerButtons]="activeProfiles?.length === profiles?.length ? null : headerButtons"></data-table>

<div class="buttons">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{ 'general.cancel' | translate }}</button>
  <button (click)="save()" class="ibexfusion-raised-button" mat-button>{{ 'general.save' | translate }}</button>
</div>
